// extracted by mini-css-extract-plugin
export var proBadge = "styles-module__proBadge___EC7E5";
export var threeDWithProBadge = "styles-module__threeDWithProBadge___SyW4z";